<dx-scroll-view [height]="height">
  <dx-data-grid
    width="100%"
    [dataSource]="ds"
    [showRowLines]="true"
    [remoteOperations]="{sorting: false, filtering: false}"
    [allowColumnReordering]="false"
    [allowColumnResizing]="false"
    [rowAlternationEnabled]="false"
    [columnHidingEnabled]="false"
    [columnAutoWidth]="true"
    [errorRowEnabled]="false"
    [stateStoring]="{enabled: false}"
    [libGridTitle]="{text: 'Consommation Carburant'}"
    [showBorders]="false">

    <dxi-column
      caption="Tracteur"
      dataField="tractor.name">
    </dxi-column>

    <dxi-column
      caption="Puissance"
      [width]="80"
      dataField="tractor.engine_power">
    </dxi-column>

    <dxi-column caption="Totale (L)" format="#0.##" dataField="flowMeterData.fuel_hr_total_consumption"></dxi-column>
    <dxi-column caption="Litres / h" format="#0.##"
                dataField="flowMeterData.fuel_hourly_consumption_rate_avg"></dxi-column>
    <dxi-column caption="Heures Moteurs" dataField="flowMeterData.engine_working_time" cellTemplate="tmp">

        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
    </dxi-column>
    <dxi-column caption="Temperature" format="#0.##" dataField="flowMeterData.fuel_temperature_avg"></dxi-column>
    <dxo-export [enabled]="true" fileName="fuel"
                [allowExportSelectedData]="true"></dxo-export>
    <dxo-summary>
      <dxi-total-item
        column="flowMeterData.fuel_temperature_avg"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
      <dxi-total-item
        column="flowMeterData.fuel_hourly_consumption_rate_avg"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
      <dxi-total-item
        column="flowMeterData.engine_working_time"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="flowMeterData.fuel_hr_total_consumption"
        valueFormat="#0.##"
        summaryType="sum">
      </dxi-total-item>
    </dxo-summary>
  </dx-data-grid>

  <div class="flex flex-row bg-gray-100 border-b-1 border-solid border-gray-300 p-4 content-center items-center">
    <span class="block mr-2 text-sm font-medium">Tracteur: </span>
    <dx-select-box
      stylingMode="underlined"
      width="240"
      displayExpr="name"
      placeholder="Tracteur"
      searchMode="contains"
      [searchExpr]="['name', 'id']"
      [searchEnabled]="true"
      (onValueChanged)="onValueChanged($event)"
      [(value)]="current"
      [items]="selected">
    </dx-select-box>
  </div>

  <div class="p-4">
    <div class="grid grid-cols-1 gap-3">
      <div>
        <!--<div class="grid p-1 grid-cols-3 gap-3 history-metrics">
          <div title="Consommation Totale" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Totale Litres</div>
            <span class="metric-value">{{flowMeterData?.fuel_hr_total_consumption | number}} <span
              class="metric-unit">L</span></span>
          </div>
          <div title="Heures Moteur" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Totale Heures Moteur</div>
            <span class="metric-value">{{flowMeterData?.engine_working_hours | number}} <span
              class="metric-unit">H</span></span>
          </div>
          <div title="Consommation L/h" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Consommation L/h</div>
            <span class="metric-value">{{flowMeterData?.fuel_hourly_consumption_rate_avg | number}} <span
              class="metric-unit">L/h</span></span>
          </div>
          <div title="Temperature" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Temperature</div>
            <span class="metric-value">{{flowMeterData?.fuel_temperature_avg | number}} <span
              class="metric-unit">°C</span></span>
          </div>
        </div>-->
      </div>

      <div *ngIf="flowMeterData">

        <dx-chart
          id="fuel-hourly-consumption-chart"
          palette="Bright"
          [dataSource]="flowMeterData.data">
          <dxo-title horizontalAlignment="center" text="Consommation L/h">
            <dxo-font color="black" [weight]="300"></dxo-font>
          </dxo-title>

          <dxo-zoom-and-pan
            [dragToZoom]="true"
            valueAxis="none"
            argumentAxis="both"
          ></dxo-zoom-and-pan>

          <dxi-series argumentField="tracker_time" valueField="fuel_hourly_consumption_rate"></dxi-series>

          <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
          <dxo-value-axis>
            <dxi-constant-line [value]="flowMeterData?.fuel_hourly_consumption_rate_avg"></dxi-constant-line>
            <dxo-label [customizeText]="valueAxisAddUnitLh"></dxo-label>
          </dxo-value-axis>

          -
          <dxo-size [height]="200" width="100%"></dxo-size>

          <dxo-common-series-settings width="2">
            <dxo-point [visible]="false"></dxo-point>
            <dxo-hover-style width="2"></dxo-hover-style>
          </dxo-common-series-settings>

          <dxo-legend [visible]="false"></dxo-legend>

          <dxo-common-axis-settings>
            <dxo-grid [visible]="true"></dxo-grid>
          </dxo-common-axis-settings>

          <dxo-export [enabled]="true"></dxo-export>

          <dxo-tooltip contentTemplate="chartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
                       [enabled]="true"></dxo-tooltip>
          <div *dxTemplate="let info of 'chartTooltip'">
            <div>{{info.value | number}} L/h - {{info.argumentText}}</div>
          </div>
        </dx-chart>

        <dx-chart
          id="fuel-hr-total-consumption-chart"
          [dataSource]="flowMeterData.data">
          <dxo-title horizontalAlignment="center" text="Consommation L">
            <dxo-font color="black" [weight]="300"></dxo-font>
          </dxo-title>

          <dxo-zoom-and-pan
            [dragToZoom]="true"
            valueAxis="none"
            argumentAxis="both"
          ></dxo-zoom-and-pan>

          <dxi-series argumentField="tracker_time" valueField="fuel_hr_total_consumption_diff"></dxi-series>

          <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
          <dxo-value-axis>
            <dxo-label [customizeText]="valueAxisAddUnit"></dxo-label>
          </dxo-value-axis>

          -
          <dxo-size [height]="200" width="100%"></dxo-size>

          <dxo-common-series-settings width="2">
            <dxo-point [visible]="false"></dxo-point>
            <dxo-hover-style width="2"></dxo-hover-style>
          </dxo-common-series-settings>

          <dxo-legend [visible]="false"></dxo-legend>

          <dxo-common-axis-settings>
            <dxo-grid [visible]="true"></dxo-grid>
          </dxo-common-axis-settings>

          <dxo-export [enabled]="true"></dxo-export>

          <dxo-tooltip contentTemplate="chartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
                       [enabled]="true"></dxo-tooltip>
          <div *dxTemplate="let info of 'chartTooltip'">
            <div>{{info.value | number}} L/h - {{info.argumentText}}</div>
          </div>
        </dx-chart>

        <dx-chart
          id="fuel-temperature-chart"
          palette="Carmine"
          [dataSource]="flowMeterData.data">
          <dxo-title horizontalAlignment="center" text="Temperature">
            <dxo-font color="black" [weight]="300"></dxo-font>
          </dxo-title>

          <dxo-zoom-and-pan
            [dragToZoom]="true"
            valueAxis="none"
            argumentAxis="both"
          ></dxo-zoom-and-pan>

          <dxi-series argumentField="tracker_time" valueField="fuel_temperature"></dxi-series>

          <dxo-argument-axis argumentType="datetime"></dxo-argument-axis>
          <dxo-value-axis>
            <dxi-constant-line [value]="flowMeterData?.fuel_temperature_avg"></dxi-constant-line>
            <dxo-label [customizeText]="valueAxisAddUnitC"></dxo-label>
          </dxo-value-axis>

          -
          <dxo-size [height]="200" width="100%"></dxo-size>

          <dxo-common-series-settings width="2">
            <dxo-point [visible]="false"></dxo-point>
            <dxo-hover-style width="2"></dxo-hover-style>
          </dxo-common-series-settings>

          <dxo-legend [visible]="false"></dxo-legend>

          <dxo-common-axis-settings>
            <dxo-grid [visible]="true"></dxo-grid>
          </dxo-common-axis-settings>

          <dxo-export [enabled]="true"></dxo-export>

          <dxo-tooltip contentTemplate="chartTooltip" [zIndex]="300000" argumentFormat="shortDateShortTime"
                       [enabled]="true"></dxo-tooltip>
          <div *dxTemplate="let info of 'chartTooltip'">
            <div>{{info.value | number}} L/h - {{info.argumentText}}</div>
          </div>
        </dx-chart>
      </div>

    </div>
  </div>
</dx-scroll-view>
